<template>
    <div class="page-container">
        <div class="fixed-header">
            <!-- <Content /> -->
            <div class="content-top">
                <div class="const-a">
                    <div class="content-top-left">
                        <img src="../assets/images/ap-1.png" alt="" @click="goToHome">
                    </div>
                    <!-- 顶部标题 -->
                    <div class="content-top-right">
                        <div class="text-a knowledge-points-title" :class="{ active: currentSubject === 'calculus' }"
                            @click="goToCalculusBC">
                            Calculus BC</div>
                        <div class="text-a" :class="{ active: currentSubject === 'microeconomics' }"
                            @click="goToMicroeconomics">Microeconomics</div>
                        <div class="text-a" :class="{ active: currentSubject === 'macroeconomics' }"
                            @click="goToMacroeconomics">Macroeconomics</div>
                        <div class="text-a" :class="{ active: currentSubject === 'physics' }" @click="goToPhysics1">
                            Physics1</div>
                        <div class="text-a" :class="{ active: currentSubject === 'biology' }" @click="goToBiology">
                            Biology</div>
                        <div class="text-a" :class="{ active: currentSubject === 'csp' }" @click="goToCSP">CSP</div>
                    </div>
                </div>
            </div>

        </div>
        <div class="scrollable-content">
            <div class="nav-container-l">
                <div class="nav-l">
                    <div class="v-line-content">
                        <div class="box1-b-l">
                            <!-- 根据questionType显示不同内容 -->
                            <!-- questionType为1时显示PDF -->
                            <div v-if="questionType === '1'" class="pdf-container">
                                <embed :src="imgurl + questionAddress" type="application/pdf" width="100%"
                                    height="600px" style="border-radius: 12px;">
                                <p v-if="!questionAddress">暂无PDF文件</p>
                            </div>

                            <!-- questionType为2时显示视频 -->
                            <div v-else-if="questionType === '2'">
                                <div class="question-name-below">
                                    <text>{{ questionName }}</text>
                                </div>

                                <video :src="imgurl + questionAddress" controls muted preload="metadata" width="100%"
                                    height="100%" style="border-radius: 12px; object-fit: cover;">
                                    您的浏览器不支持视频播放。
                                </video>
                               
                            </div>

                            <!-- questionType为3时显示富文本 -->
                            <div v-else-if="questionType === '3'">
                                <div class="question-name-above">
                                    <text>{{ questionName }}</text>
                                </div>
                                <div class="rich-text-container" v-html="questionNotes"></div>
                            </div>

                            <!-- 其他情况显示默认内容 -->
                            <div v-else>
                                <p>暂不支持的文件类型</p>
                            </div>
                        </div>
                        <!-- 删除原来的box2-b-l部分 -->
                    </div>
                </div>




            </div>
        </div>
         <!-- 修改底部为非固定 -->
         <div class="footer-content">
            <Concat />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute,useRouter } from 'vue-router'
import Concat from '../components/Concat.vue'
import Content from '../components/Content.vue'
import videoSource from '../assets/videos/video.mp4'
const route = useRoute();
const router = useRouter();

const videoItem = ref(null)
const imgurl = 'https://question-bank-hao.obs.cn-southwest-2.myhuaweicloud.com'


// 定义响应式数据
const questionName = ref('')
const questionAddress = ref('')
const questionImage = ref('')
const questionNotes = ref('')
const questionType = ref('')


onMounted(() => {
    // 从路由参数中获取数据
    const id = route.query.id
    questionAddress.value = route.query.questionAddress || ''
    questionImage.value = route.query.questionImage || ''
    questionName.value = route.query.questionName || ''
    questionNotes.value = route.query.questionNotes || ''
    questionType.value = route.query.questionType || ''

    // 使用这些参数进行渲染
})
// 页面导航函数
const goToHome = () => {
    router.push('/')
}

const goToMicroeconomics = () => {
    router.push('/calculusbc')
}

const goToBiology = () => {
    router.push('/calculusbc')
}

const goToPhysics1 = () => {
    router.push('/calculusbc')
}

const goToCSP = () => {
    router.push('/calculusbc')
}

const goToMacroeconomics = () => {
    router.push('/calculusbc')
}

const goToCalculusBC = () => {
    router.push('/calculusbc')
}


</script>

<style scoped>

.question-name-above,
.question-name-below {
    font-size: 32px;
    font-weight: bold;
    margin: 20px 0;
    /* text-align: center; */
    
}

.rich-text-container {
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 12px;
    min-height: 600px;
    text-align: left;
    font-size: 25px;
}

/* 覆盖富文本内容中的居中样式 */
.rich-text-container * {
    text-align: left !important;
}
.question-name {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
}

.rich-text-container {
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 12px;
    min-height: 600px;
    text-align: left;
}




/* -----顶部标题样式--- */
.knowledge-points-title {
    white-space: nowrap;
}
/* .fixed-header {
    flex-shrink: 0;
} */

.content-top {
    width: 1440px;
    height: 100px;
    width: 100vw;
    background-color: black;
    height: 100px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

.const-a {
    width: 1200px;
    height: 100px;
    display: flex;
    align-items: center;
}

.content-top-left {
    width: 202px;
    height: 44px;
    margin-right: 108px;
}

.content-top-left img {
    width: 202px;
    height: 44px;
    cursor: pointer;
}

.content-top-right {
    width: 890px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.text-a {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 22px;
    color: #FFFFFF;
    margin-right: 39px;
    cursor: pointer;
}

.text-a.active {
    text-decoration: underline;
}
.page-container {
    display: flex;
    flex-direction: column;
    /* height: 100vh; */
    min-height: 100vh;
}

.fixed-header {
    flex-shrink: 0;
}

.scrollable-content {
    /* flex: 1; */
    overflow-y: auto;
    /* max-height: 1732px; */
}

.footer-content {
    flex-shrink: 0;
    margin-top: 63px;
}

@import '../pages/index-v.css'
</style>